import { Controller } from "@hotwired/stimulus";

const FORM_FIELDS = ["input", "select", "textarea", "button"];

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-start", this.handleSubmitStart);
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart);
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd);
  }

  handleSubmitStart = (_event) => {
    this.setFieldsDisabled(true);
  };

  handleSubmitEnd = (_event) => {
    this.setFieldsDisabled(false);
  };

  setFieldsDisabled(disabled) {
    this.element.querySelectorAll(FORM_FIELDS).forEach((field) => {
      field.disabled = disabled;
    });
  }
}
